import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getUser, login, logout, mfaSendEmailCode, mfaVerifyEmail } from '@/api/auth-api';
import { clearTokens, getRefreshToken } from '@/api/token-storage';
import { dbaKeys } from './query-keys';

export function useLogin() {
  return useMutation({ mutationFn: login });
}

export function useMfaSendEmailCode() {
  return useMutation({ mutationFn: mfaSendEmailCode });
}

export function useMfaVerifyEmail() {
  return useMutation({ mutationFn: mfaVerifyEmail });
}

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const refreshToken = getRefreshToken();
      if (refreshToken) {
        await logout(refreshToken);
      }
    },
    onSettled: () => {
      clearTokens();
      queryClient.clear();
    },
  });
}

export function useCurrentUser() {
  return useQuery({ queryKey: dbaKeys.user, queryFn: getUser });
}
